import api from '../../lib/api';

export const addDiary = data =>
  function get(dispatch) {
    api
      .sendPost('/public-dashboard/action/diary', data, (error, response) => {
        if (error) return console.error(error);
        dispatch(addDiarySuccess(response.data));
        return dispatch(getDiaries());
      });
  };

export const deleteDiary = diaryId =>
  function get(dispatch) {
    api
      .sendDelete(`/public-dashboard/action/diary/${diaryId}`, (error, response) => {
        if (error) return console.error(error);
        dispatch(getDiaries());
      });
  };

export const updateDiary = data =>
  function get(dispatch) {
    api
      .sendPut(`/public-dashboard/action/diary/${data.id}`, data, (error, response) => {
        if (error) return console.error(error);
        return dispatch(getDiaries());
      });
  };

export const getDiaries = () =>
  function get(dispatch) {
    api
      .sendGet('/public-dashboard/action/diary', (error, response) => {
        if (error) return console.error(error);
        return dispatch(getDiariesSuccess(response.data.data));
      });
  };

export const getDiariesSuccess = data => ({
  type: 'GET_DIARIES_SUCCESS',
  data,
});

export const addDiarySuccess = data => ({
  type: 'CREATE_DIARY_SUCCESS',
  data,
});



// WEBPACK FOOTER //
// ./src/Actions/Dashboard/diary.js